import { useEffect } from "react";
import { Box, CardContent } from "@mui/material";
import { mdiTimerOutline } from "@mdi/js";
import dayjs from "dayjs";
import Icon from "@mdi/react";

import CardWithAvatar from "components/CardWithAvatar";
import DateCountdown from "components/DateCountdown";
import { AugmentedEvent } from "store/appDataSlice";

export type EventCountdownType = "vote" | "start-date" | "hide";
export interface EventCountdownProps {
  countdownType: EventCountdownType;
  event: AugmentedEvent;
  onTypeChange: (type: EventCountdownType) => void;
}

function EventCountdown(props: EventCountdownProps) {
  const { countdownType, event, onTypeChange } = props;

  /**
   * Change countdown type when countdown finishes
   */
  function handleOnFinish(): void {
    if (countdownType === "vote") {
      onTypeChange("start-date");
    } else if (countdownType === "start-date") {
      // A second was added because now will always be behind 1 second when [handleOnFinish] os triggered
      const now = dayjs().add(1, "second");
      const eventStartDate = dayjs(event.start_date);

      if (now.isAfter(eventStartDate) || now.isSame(eventStartDate)) {
        onTypeChange("hide");
      }
    }
  }

  useEffect(() => {
    const now = dayjs();
    if (now.isBefore(dayjs(event.vote_before))) {
      onTypeChange("vote");
    } else if (now.isBefore(dayjs(event.start_date))) {
      onTypeChange("start-date");
    } else {
      onTypeChange("hide");
    }
  }, [event.vote_before, event.start_date]);

  if (countdownType === "hide") {
    return null;
  }

  return (
    <CardWithAvatar
      data-testid='event-countdown'
      icon={<Icon path={mdiTimerOutline} size={1.2} />}
      noHeaderGutterBottom
      subheader={countdownType === "vote" ? "Until voting time expires" : "Until event starts"}
      title='Countdown'
    >
      <CardContent>
        <Box display='flex' justifyContent='center'>
          <DateCountdown
            date={countdownType === "vote" ? event.vote_before : event.start_date}
            onFinish={handleOnFinish}
          />
        </Box>
      </CardContent>
    </CardWithAvatar>
  );
}

export default EventCountdown;
